import React from 'react';

import { ColorPaletteContext } from '@neptune/colors-domain';

export function useColorsPaletteContext() {
  return React.useContext(ColorPaletteContext);
}
